// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"4ce65a7a","581":"6f4acfad"}[chunkId] + ".chunk.js";
};